export default __webpack_public_path__ + "static/media/WSS.1ebfc335.png";